module.exports = __webpack_public_path__ + "static/media/edit-blue.b3f25adf.svg";